import './Icon.css';

/**
 * Icon component that uses the SVG sprite
 * @param {string} name - Icon name (e.g., "dashboard", "users")
 * @param {string} size - Size variant: "xs", "sm", "md", "lg", "xl"
 * @param {string} className - Additional CSS classes
 */
export const Icon = ({ name, size = 'md', className = '' }) => {
  return (
    <span className={`icon icon-${size} ${className}`}>
      <svg>
        <use href={`#icon-${name}`} />
      </svg>
    </span>
  );
};

export default Icon;
